export default "__VITE_ASSET__Cn0CAT5J__"